// extracted by mini-css-extract-plugin
export default {"modalArea":"Modal_modalArea__N0ZVu","dark":"Modal_dark__VKaPt","body":"Modal_body__0Gjhp","modalCover":"Modal_modalCover__GeAmQ","positionBottom":"Modal_positionBottom__-ShQE"};